export enum UserType {
  RESTAURANT = 'restaurant',
  NURSERY = 'nursery',
}
